exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cell[data-v-10c5f053] {\n  height: 0.8rem;\n  padding: 0.75rem 0.5rem 0.5rem 0.5rem;\n}\n.cell .title[data-v-10c5f053] {\n  text-indent: 0.4rem;\n  font-weight: bold;\n  position: relative;\n}\n.cell .title span[data-v-10c5f053] {\n  font-weight: bold;\n}\n.cell .title .leftstyle[data-v-10c5f053] {\n  width: 0.15rem;\n  height: 0.8rem;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  display: block;\n  margin: auto 0;\n  position: absolute;\n  background: #333;\n}", ""]);

// exports
